import { render, staticRenderFns } from "./TaxonomySearchDropdown.vue?vue&type=template&id=be8dd1e8"
import script from "./TaxonomySearchDropdown.vue?vue&type=script&lang=js"
export * from "./TaxonomySearchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports